import { installDemoFetchMocks } from "../installDemoFetchMocks";

// Currently, axios mocking is wired via http/index.js adapter when localStorage.isDemo === "1".
// This installer is intentionally thin to keep demo code removable.
export function installDemo() {
  installDemoFetchMocks();
}

